import { modelOptions, prop, Severity } from '@typegoose/typegoose';
import { RecommendationsModel } from "./recommendations.model";

@modelOptions({
  options: {allowMixed: Severity.ALLOW},
  schemaOptions: {_id: false}
})
export class TopRecommendationsModel {
  @prop({required: true})
  global: RecommendationsModel[];

  @prop({required: true})
  group: RecommendationsModel[];
}
